import { ConfiguratorRequest } from 'components/ordering/configurator/api/configurator-request.js'
import {
  AddToBasketFailure,
  AddToBasketSuccess,
  parseAddToBasketResponse,
} from 'components/ordering/add-to-basket/basket-parser.js'

type PostAddToBasketPayload = {
  productId: number
  productConfiguration: string
}

export class PostAddToBasket extends ConfiguratorRequest<AddToBasketSuccess, AddToBasketFailure> {
  path: string
  override init: RequestInit

  constructor({ productId, productConfiguration }: PostAddToBasketPayload) {
    super()
    this.path = 'xhr/order-form/basket/add/'

    const formData = new FormData()
    formData.append('product', productId.toString())
    formData.append('quantity', '1')
    formData.append('product_configuration', productConfiguration)

    this.init = {
      method: 'POST',
      body: formData,
    }
  }

  override parseResponse = (data: unknown) =>
    parseAddToBasketResponse({ statusCode: 200, body: data }) as AddToBasketSuccess

  override parseError = (status: number, data: unknown) =>
    parseAddToBasketResponse({ statusCode: status, body: data }) as AddToBasketFailure
}
